'use strict';

(function () {
    'use strict';

    translationsConfig.$inject = ['$translateProvider'];
    angular.module('app.iot').config(translationsConfig);

    function translationsConfig($translateProvider) {
        'ngInject';

        $translateProvider.translations('en-US', {
            'timeframe': {
                'name': 'name'
            },
            'water': {
                'Water tanks level': 'Water tanks level'
            },
            'iot': {
                'Urban monitoring': 'Urban monitoring',
                'Infrastructure management': 'Infrastructure management',
                'Analytics historical data': 'Analytics historical data',
                'Parking management': 'Parking prohibition sensors',
                'Humidity': 'Humidity',
                'Devices': 'Device',
                'Wind': 'Wind',
                'Gasses': 'Gasses',
                'see more': 'see more',
                'Locations': 'Locations',
                'Modality': 'Measurement',
                'Download': 'Download',
                'Aggregation': 'Aggregation',
                'Dates range': 'Date range',
                'Calm': 'Calm',
                'Date': 'Date',
                'Speed (km/h)': 'Speed (km/h)',
                'Timeframe': 'Timeframe',
                'Streaming data': 'Streaming data',
                'Add all': 'Add all',
                'Remove all': 'Remove all',
                'Weather conditions': 'Weather conditions',
                'Gasses measurements': 'Gasses measurements',

                'Smart City IoT infrastructure': 'Smart City IoT infrastructure',

                'Show out of range measurements': 'Show out of range measurements',
                'Hide out of range measurements': 'Hide out of range measurements',

                'Invalid Dates and Aggregation combination': 'The number of records is too large for be displayed for the selected combination of dates and aggregation to be displayed.',
                'Add more locations': 'Add more locations',
                'Urban environment monitoring': 'Environmental monitoring',
                'Urban environment': 'Urban environment',
                'Historical data': 'Historical data',

                'Water environment monitoring': 'Water environment monitoring',
                'water conditions': 'Water conditions',

                'warning-disclamer': 'Sensors are currently being calibrated. Measured values may differ from the actual ones.'
            },
            'people': {
                'Crowd Estimation': 'Crowd Estimation',
                'Zone': 'Zone',
                'see more': 'see more',
                'unit': 'People'
            },
            'sound': {
                'Sound Levels': 'Sound Levels',
                'Zone': 'Zone',
                'see more': 'see more'
            },
            'traffic': {
                'Traffic Estimation': 'Traffic Estimation',
                'Station': 'Station',
                'see more': 'see more',
                'car': 'Car',
                'bus': 'Bus',
                'person': 'Person',
                'motorbike': 'Motorbike',
                'bicycle': 'Bicycle',
                'truck': 'Truck'
            }
        });
    }
})();